// Decorative paths from the ZIPA 1.1.0 prototype (Tabler, MIT).
export function MemberIcon({
  kind,
}: {
  kind:
    | 'card'
    | 'booking'
    | 'tickets'
    | 'details'
    | 'qr'
    | 'arrow'
    | 'redeem'
    | 'referral'
    | 'reserve'
    | 'back';
}) {
  const paths = {
    back: ['M15 6l-6 6l6 6'],
    reserve: [
      'M12.5 21h-6.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5',
      'M16 3v4M8 3v4M4 11h16M16 19h6M19 16v6',
    ],
    redeem: [
      'M3 8m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z',
      'M12 8v13M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7',
      'M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5',
    ],
    referral: ['M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0', 'M16 19h6M19 16v6M6 21v-2a4 4 0 0 1 4 -4h4'],
    card: [
      'M3 4m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z',
      'M9 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0',
      'M15 8h2M15 12h2M7 16h10',
    ],
    booking: [
      'M11.5 21H6a2 2 0 0 1 -2 -2V7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6',
      'M16 3v4M8 3v4M4 11h16M15 19l2 2l4 -4',
    ],
    tickets: [
      'M15 5v2M15 11v2M15 17v2',
      'M5 5h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1 -2 2H5a2 2 0 0 1 -2 -2v-3a2 2 0 0 0 0 -4V7a2 2 0 0 1 2 -2',
    ],
    details: ['M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0', 'M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2'],
    qr: [
      'M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4z',
      'M14 14h3M20 14v.01M14 14v3M14 20h3M17 17h3M20 17v3',
    ],
    arrow: ['M9 6l6 6l-6 6'],
  };
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {paths[kind].map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}
